import { render, staticRenderFns } from "./createAuth.vue?vue&type=template&id=31331a6a&scoped=true&"
import script from "./createAuth.vue?vue&type=script&lang=js&"
export * from "./createAuth.vue?vue&type=script&lang=js&"
import style0 from "./createAuth.vue?vue&type=style&index=0&id=31331a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31331a6a",
  null
  
)

export default component.exports